import { ApolloClient, DefaultOptions } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import { onError } from "apollo-link-error";
import { ApolloLink, from } from "apollo-link";
import apolloUploadClient from "apollo-upload-client";
import { i18n } from "@/lang";
import { getEndpointByGuessing } from "@/utils/environment";

const httpLink = apolloUploadClient.createUploadLink({
  // You should use an absolute URL here
  uri: getEndpointByGuessing()
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = sessionStorage.getItem("cedoon_token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      userLanguage: i18n.locale || "en"
    }
  };
});

const logoutLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors && graphQLErrors[0] && graphQLErrors[0].message.startsWith("Access denied")) {
    sessionStorage.clear();
    window.location.href = "/";
  }
});

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
};

// Create the apollo client
export const graphqlClient = new ApolloClient({
  link: from([authLink, logoutLink, httpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: defaultOptions
});
